import { render, staticRenderFns } from "./LessonDevelopment.vue?vue&type=template&id=631e201e&scoped=true"
import script from "./LessonDevelopment.vue?vue&type=script&lang=js"
export * from "./LessonDevelopment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e201e",
  null
  
)

export default component.exports